
export const defaultKeywords = `LYSOSOMAL STORAGE DISORDER, FABRY'S DISEASE, METACHROMATIC LEUKODYSTROPHY, MUCOPOLYSACCHARIDOSIS, GAUCHER'S DISEASE, ADRENOLEUKODYSTROPHY,
KRABBE, ENZYME REPLACEMENT THERAPY, STEM CELL TRANSPLANTATION, CELL AND GENE THERAPY`;

export const defaultFilters = {
    year: "",
    location: [],
    topic: [],
    affs: [],
    experts: [],
    advBoard: "",
    isActive: "",
    advanceSort: [],
    listType: {
        label: "SHORT LIST",
        value: "SHORT_LIST"
    },
    isActive:{},
    operator:  { value: "OR", label: "OR" },
    addedBy: [],
    size: 10,
    from: 0,
    sort: {
        value: "mld_citation_count",
        label: "MLD Related Citation"
      }
  }